import { render, staticRenderFns } from "./AstaChangeAdmin.vue?vue&type=template&id=76ea7bfc&scoped=true&"
import script from "./AstaChangeAdmin.vue?vue&type=script&lang=js&"
export * from "./AstaChangeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AstaChangeAdmin.vue?vue&type=style&index=0&id=76ea7bfc&lang=scss&scoped=true&"
import style1 from "./AstaChangeAdmin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea7bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ea7bfc')) {
      api.createRecord('76ea7bfc', component.options)
    } else {
      api.reload('76ea7bfc', component.options)
    }
    module.hot.accept("./AstaChangeAdmin.vue?vue&type=template&id=76ea7bfc&scoped=true&", function () {
      api.rerender('76ea7bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaChangeAdmin.vue"
export default component.exports